import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getFile,
  getFileBlob,
  getRDM,
  getVehicleInformation,
  getVehicleInformationDownload,
  getVehicleInformationDownloadBlob,
  updateRDM,
} from "./reportingAPI";

const initialState = {
  data: null,
  data2: [],
  data3: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  dataId: null,
};

export const fetchReporting = createAsyncThunk(
  "reporting/fetchReporting",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchReportingVehicleInfo = createAsyncThunk(
  "reporting/fetchReportingVehicleInfo",
  async (payload) => {
    const response = await getVehicleInformation(payload);
    return response;
  }
);

export const fetchReportingVehicleInfoDownload = createAsyncThunk(
  "reporting/fetchReportingVehicleInfoDownload",
  async (payload) => {
    const response = await getVehicleInformationDownload(payload);
    return response;
  }
);

export const fetchReportingVehicleInfoDownloadBlob = createAsyncThunk(
  "reporting/fetchReportingVehicleInfoDownloadBlob",
  async (payload) => {
    const response = await getVehicleInformationDownloadBlob(payload);
    return response;
  }
);

export const editRdm = createAsyncThunk(
  "reporting/updateRdm",
  async (payload) => {
    const response = await updateRDM(payload);
    return response;
  }
);
export const fetchRdm = createAsyncThunk(
  "reporting/fetchRdm",
  async (payload) => {
    const response = await getRDM(payload);
    return response;
  }
);
export const fetchFile = createAsyncThunk(
  "reporting/fetchFile",
  async (payload) => {
    const response = await getFile(payload);
    return response;
  }
);
export const fetchFileBlob = createAsyncThunk(
  "reporting/fetchFileBlob",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const reportingSlice = createSlice({
  name: "reporting",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReporting.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReporting.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchReportingVehicleInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportingVehicleInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchRdm.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRdm.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchReportingVehicleInfoDownload.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportingVehicleInfoDownload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchReportingVehicleInfoDownloadBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchReportingVehicleInfoDownloadBlob.fulfilled,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
        }
      )
      .addCase(fetchFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFileBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFileBlob.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editRdm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editRdm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = reportingSlice.actions;

export const selectReporting = (state) => state.reporting.data;
export const selectReporting2 = (state) => state.reporting.data3;
export const selectManager = (state) => state.reporting.data2;
export const selectLoading = (state) => state.reporting.loading;
export const selectError = (state) => state.reporting.error;
export const selectPageNo = (state) => state.reporting.pageNo;
export const selectPageSize = (state) => state.reporting.pageSize;
export const selectTotalRecord = (state) => state.reporting.totalRecord;
export const selectSelected = (state) => state.reporting.selected;
export const selectResult = (state) => state.reporting.result;

export default reportingSlice.reducer;
